<template>
  <!-- https://getbootstrap.com/docs/4.1/examples/sign-in/ - https://getbootstrap.com/docs/4.1/examples/sign-in/ -->
  <div class="text-center registration-form">
    <form class="form-signup" @submit.prevent="onSubmit">
      <!-- <img class="mb-4" src="../../assets/brand/bootstrap-solid.svg" alt="" width="72" height="72"> -->
      <!-- <img class="mb-4" src="../assets/img/logo/logo-dame-una-mano_imageonly_purple.svg" alt="" width="72" height=""> -->
      <!-- <h1 class="h3 font-weight-normal" style="margin-bottom: 0;">Inscríbete a</h1> -->
      <!-- <h1 class="h3 mb-3 font-weight-normal">Dame Una Mano</h1> -->
      <h3 class="mb-3 font-weight-normal" style="color: var(--coredarkcolor);" ref="pageTitle">Organization Registration</h3>
      <label for="inputEmail" class="sr-only">Email</label>
      <input type="email" id="inputEmail" class="form-control" placeholder="Email" required autofocus v-model="email">
      <!-- <label for="inputPhone" class="sr-only">Phone</label> -->
      <!-- <input type="text" id="inputPhone" class="form-control" placeholder="Numero de Celular	" required autofocus v-model="phone"> -->
      <label for="inputPassword" class="sr-only">Password</label>
      <input type="password" id="inputPassword" class="form-control" placeholder="Password" required v-model="password">

      <!-- <div class="checkbox mb-3">
        <label>
          <input type="checkbox" value="remember-me"> Remember me
        </label>
      </div> -->
      <div class="form-check mb-3">
        <input class="form-check-input" type="checkbox" :value="true" v-model="consent">
        <label class="form-check-label">
          <!-- I consent to the <router-link style="" :to="{ name: 'Terms and Conditions' }" class="">Terms & Conditions</router-link> and <router-link style="" :to="{ name: 'Privacy Policy' }" class="">Privacy Policy</router-link> -->
          I consent to the <router-link :to="{ name: 'Content', params: { slug: 'terms' } }" target="_blank">Terms & Conditions</router-link> and <router-link :to="{ name: 'Content', params: { slug: 'privacy' } }" target="_blank">Privacy Policy</router-link>
        </label>
      </div>

      <button v-if="consent" class="btn btn-lg btn-primary btn-block" type="submit">Sign Up</button>
      <p v-if="registrationError" class="pt-2"><strong>There is an error with your registration. You may already have an account with this email, try <router-link :to="{ name: 'Login' }">logging in</router-link>!</strong></p>
      <!-- <p class="mt-5 mb-5 text-muted">&copy; 2017-2018</p> -->
      <p class="pt-4" style="margin-bottom: 0;">Already have a profile? <router-link to="/login" class="">Login</router-link></p>
      <p class="pt-1"><router-link to="/candidate-registration" class="">I'm looking for opportunities</router-link></p>
      <!-- <p class="pt-4 pb-5 text-muted">¿Preguntas? 350-4775478</p> -->
    </form>
  </div>
</template>

<script>
  import axios from 'axios';
  // import axios from '../../axios'; // Don't have to name it axios, can name it anything - Lecture 348

  export default {
    data () {
      return {
        email: '',
        phone: '',
        password: '',

        consent: false,

        registrationError: false,

        aakashid: 4, // Used for holding the id of the user with the email aakash@enginehire.ca, this is so I can send myself update emails when things happen
      }
    },
    created() {
      // Scroll the window up
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    mounted() {
      document.title = this.$refs.pageTitle.innerHTML
    },
    methods: {
      onSubmit () {
        const formData = {
          email: this.email,
          password: this.password,
        }
        console.log(formData)
        // axios.post('https://vuejs-http-cf9e8.firebaseio.com/users.json', formData)
        // axios.post('/users.json', formData)
        // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', formData)
        // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', {
        // axios.post('http://127.0.0.1:8000/optimum/create-candidate/', {
        //   email: formData.email,
        //   password: formData.password,
        //   // returnSecureToken: true,
        //   agency: 2,
        // })
        //   .then(res => console.log(res))
        //   .catch(error => console.log(error))

        // https://vuex.vuejs.org/guide/actions.html
        // Once the user has been registered then we log them in
        // this.$store.dispatch('registerCandidate', {email: this.email, password: this.password}).then(() => {

        // THIS IS CAUSING PROBLEMS - CAN'T DO API CALL WITHOUT AUTHENTICATION
        // Get the id of the aakash@enginehire.ca user
        // this is necessary because the user changes depending on whether we are using the dev or production database
        // axios.get('/api/people/?email=aakash@enginehire.ca')
        //   .then(res => {
        //     console.log('Getting aakashid')
        //     console.log(res)
        //     console.log(res.data)
        //     console.log(res.data[0].id)
        //     this.aakashid = res.data[0].id
        //   })
        //   .catch(error => console.log(error))

        this.$store.dispatch('registerUser', {email: this.email, password: this.password, user_type: 'employer', status: '', phone: this.phone}).then(() => {
          // this.$store.dispatch('testAction')
          // this.$store.dispatch('login', {email: this.email, password: this.password}).then(() => {
          //   this.$store.dispatch('getUser')
          // })
          console.log('Done registration')
          // Send myself an email notification that a new candidate registered
          this.$store.dispatch('sendEmail',
            {
              subject: 'New ThriveHire Employer Registration!',
              message: 'Email: '+this.email,
              // from: 'info@thrivehire.co',
              from: 'info@thrivehire.co',
              email: 'aakash@enginehire.ca',
              reply: 'info@thrivehire.co',
              userID: this.aakashid,
            }
          )

//           this.$store.dispatch('sendEmail', {
//                   subject: 'Welcome',
//                   message: '\
// Welcome to ThriveHire!\n\n\
// Thank you for joining our community. We’re looking forward to working with you and sharing your organization’s impactful work and opportunities.\n\n\
// We would be happy to set up a short call with you to learn more about your needs, to highlight ways that ThriveHire may benefit you, and to clarify any questions you may have.\n\n\
// Please schedule a time that is convenient for you for this call here: calendly.com/hmundeva/30min?back=1&month=2020-01\n\n\
// We’re looking forward to speaking with you!\n\n\
// Kind regards,\n\n\
// Hayley Mundeva\n\
// Founder/CEO, ThriveHire',
//                   from: 'info@dameunamano.co',
//                   email: authData.email,
//                   reply: 'hmundeva@thrivehire.org',
//                   userID: res.data.pk,
//                 })
        })
        // this.$store.dispatch('test')

        .catch(error => {
          console.log('problemoo with reg')
          this.registrationError = true
        })
      }
    }
  }
</script>

<style scoped>
/* Bootstrap sign up form */
/* https://getbootstrap.com/docs/4.1/examples/sign-in/ - https://getbootstrap.com/docs/4.1/examples/sign-in/signin.css */

  #dark-navbar {
    display: none;
  }

  .registration-form {
    height: 100vh;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #f5f5f5;
  }

  .form-signup {
    width: 100%;
    max-width: 330px;
    /* min-width: 300px; */
    padding: 15px;
    margin: auto;
  }
  .form-signup .checkbox {
    font-weight: 400;
  }
  .form-signup .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
  }
  .form-signup .form-control:focus {
    z-index: 2;
  }
  .form-signup input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .form-signup input[type="text"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .form-signup input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/employers/Registration.vue